export const MANAGER = 'Manager';
export const LANDLORD = 'Landlord';
export const TENANT = 'Tenant';
export const CASE_MANAGER = 'CaseManager';
